import AddXSymbolMessageModal from "./AddXSymbolMessageModal";

export default AddXSymbolMessageModal;
